<template>
    <div class="puzzles-item-wrapper">
        <div class="puzzles-inner puzzles-inner-buy">
            <div
                @click="$modal.show('puzzle', {id: puzzle.id})"
                :style="{
                    'background-image':
                    puzzle.completed == 100 ?
                    'url(' + puzzle.image + ')' :
                    'url(' + puzzle.blurred + ')'
                }"
                class="puzzles-image"
                :class="{'puzzles-item-complete': puzzle.completed == 100}"
            >
                <div
                    v-if="puzzle.completed != 100"
                    @click="$modal.show('puzzle', {id: puzzle.id})"
                    class="puzzles-item-progress"
                >{{ puzzle.completed }}%</div>
                <svg
                    v-if="puzzle.completed != 100"
                    @click="$modal.show('puzzle', {id: puzzle.id})"
                    class="puzzles-item-progress-svg"
                    viewBox="-2 -2 124 124"
                >
                    <path
                        class="puzzles-item-progress-meter"
                        :id="'base' + index"
                        d="M60,6A54,54 0 0 1 60,114A54,54 0 0 1 60,6z"
                        stroke-width="10"
                    />
                    <g :id="'progress-value' + index"></g>
                </svg>
            </div>
            <div
                @click="showContext = !showContext"
                ref="contextAvatar"
                :style="{
                    'background-image':
                    puzzle.owner && puzzle.owner.avatar ?
                    'url(' + puzzle.owner.avatar + ')' :
                    ''
                }"
                class="puzzles-owner-avatar"
                :class="{
                    'no-avatar':
                    !puzzle.owner || !puzzle.owner.avatar
                }"
            ></div>
            <div
                @click="showContext = !showContext"
                ref="contextName"
                class="puzzles-owner-name"
                :class="{'puzzles-owner-open': showContext}"
            >{{ puzzle.owner ? puzzle.owner.first_name : '' }}</div>
            <div
                v-if="showContext"
                v-click-outside="{
                    exclude: ['contextAvatar', 'contextName'],
                    handler: 'clickOutsideContext'
                }"
                class="puzzles-item-dropdown context"
            >
                <router-link
                    v-if="puzzle.owner && puzzle.owner.id"
                    :to="'/profile/' + puzzle.owner.id"
                    class="context-item"
                >Перейти в профиль</router-link>
                <router-link
                    v-if="puzzle.owner && puzzle.owner.puzzle_album_id"
                    :to="'/photos/' + puzzle.owner.id + '/' + puzzle.owner.puzzle_album_id"
                    class="context-item"
                >Открыть все пазлы этого пользователя</router-link>
                <div
                    @click="remove"
                    class="context-item"
                ><span class="link-red">Удалить</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PuzzlesItem',
        props: {
            puzzle: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        mixins: [],
        data() {
            return {
                showContext: false
            }
        },
        computed: {

        },
        created() {
        },
        methods: {
            remove() {
                this.$modal.show('dialog', {
                    title: 'Внимание!',
                    text: 'Пазл будет удалён. Продолжить?',
                    buttons: [
                        {
                            title: 'Удалить',
                            handler: () => {
                                this.$store.dispatch('puzzles/remove', this.puzzle.id)
                                .then(() => {
                                    this.showContext = false;
                                    this.$modal.hide('dialog');
                                    this.$emit('set-progress');
                                })
                                .catch(() => {
                                    this.$modal.hide('dialog');
                                });
                            }
                        },
                        {
                            title: 'Отмена'
                        }
                    ]
                })
            },      
            clickOutsideContext() {
                this.showContext = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/styles/pages/_puzzles';
</style>